// This three are closer to stars
// Class D (planetoid or moon with little to no atmosphere)
// Class Y (toxic atmosphere, high temperatures)
// Class N (sulfuric)

// Class K (habitable, as long as pressure domes are used)
// Class L (marginally habitable, with vegetation but no animal life)
// Class M (terrestrial)

// // Two types of giants?
// Class J (gas giant)
// Class T (gas giant)

// // This can be anywhere in a system
// Class H (generally uninhabitable)

export enum PlanetClass {
    D = 0,
    Y = 1,
    N = 2,

    H = 3,

    J = 4,
    T = 5,

    K = 6,
    L = 7,
    M = 8
}
